import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: '2-digit',
  minute: '2-digit'
};

export const TablaHistorial = (props) => {
    console.log(props.datos)
  return (
    <React.Fragment>
      {Array.isArray(props.datos) && props.datos?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Fecha</TableCell>
              <TableCell>Usuario</TableCell>
              <TableCell>Campo</TableCell>
              <TableCell>Valor Anterior</TableCell>
              <TableCell>Valor Nuevo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.datos.map((solicitud) => {
              if (solicitud.campo !== "Destino") {
                return (
                  <TableRow key={solicitud?.idHistorico.toString()}>
                    <TableCell>
                      {new Date(solicitud.fecha).toLocaleString(
                        "es",
                        optionsfecha
                      )}
                    </TableCell>
                    <TableCell>{solicitud?.usuario?.userName ? solicitud?.usuario?.userName : "-"}</TableCell>
                    <TableCell>{solicitud.campo}</TableCell>
                    <TableCell style={{ color: "red", fontWeight: "bold" }}>
                      {solicitud.valorAnterior === "" ? "-" : solicitud.valorAnterior}
                    </TableCell>
                    <TableCell style={{ color: "green", fontWeight: "bold" }}>
                      {solicitud.valorNuevo === "" ? "-" : solicitud.valorNuevo}
                    </TableCell>
                  </TableRow>
                )
              }
              return null
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontStyle: "italic", fontSize: "1.1rem" }}>
          No hay datos
        </Typography>
      )}
    </React.Fragment>
  );
};